/* Slanciata — comportement de la page produit clonee de Luveon.
   Remplace le runtime GemPages (carrousels, galerie, accordeons, date de livraison)
   et l'app Kaching (offre 1 legging / 1 legging = 1 in regalo). Le balisage et le CSS
   sont ceux de la source ; ce fichier ne fait que les animer. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var PJ = null;
  try { PJ = JSON.parse(($('#sl-product') || {}).textContent || 'null'); } catch (e) { PJ = null; }
  var SW = { 'Nero': '#000000', 'Grigio': '#808080', 'Verde Pavone': '#00869a', 'Beige': '#EAD8AB', 'Blu Navy': '#1f3554',
             'Rosa': '#f06ca1', 'Azzurro': '#31c1e6', 'Giallo': '#FFE500', 'Lilla': '#cad6e4' };

  /* ---------------- carrousels ---------------- */
  var carousels = {};
  function Carousel(root) {
    var slider = $('.gem-slider', root);
    if (!slider) return null;
    var items = Array.prototype.slice.call(slider.children).filter(function (e) { return e.classList.contains('gem-slider-item'); });
    if (!items.length) return null;
    var feature = root.getAttribute('type') === 'gp-feature-image-carousel';
    var idx = 0;
    var dots = $$('.gp-carousel-dot-container button', root);
    var on = dots[0] ? dots[0].style.backgroundColor : '';
    var off = dots[1] ? dots[1].style.backgroundColor : '';
    function size() {
      if (!feature) return;
      var w = slider.clientWidth;
      items.forEach(function (it) { it.style.width = w + 'px'; it.style.minWidth = w + 'px'; it.style.maxWidth = w + 'px'; });
    }
    // GemPages n'utilise ni gap ni marge : chaque diapo est decalee de (index x ecart) par translate3d.
    // L'ecart vient de --cg / --cg-tablet / --cg-mobile du slider, sinon il se deduit des largeurs.
    function gapPx() {
      var st = slider.getAttribute('style') || '', w = window.innerWidth;
      var key = w < 768 ? '--cg-mobile' : (w < 1025 ? '--cg-tablet' : '--cg');
      var m = st.match(new RegExp(key + ':\\s*([\\d.]+)px'));
      if (!m && key !== '--cg') m = st.match(/--cg:\s*([\d.]+)px/);
      if (m) return parseFloat(m[1]);
      // ecarts internes a GemPages releves sur la source (captures de commentaires : 16 px)
      var FIX = { 'g4UFC9FBQI': 16, 'gSDW6zEKKV': 16 };
      if (FIX[root.getAttribute('data-id')] != null) return FIX[root.getAttribute('data-id')];
      var iw = items[0].getBoundingClientRect().width, sw = slider.clientWidth;
      var n = iw ? Math.floor((sw + 1) / iw) : 1;
      if (n > 1) { var g = (sw - n * iw) / (n - 1); if (g > 0 && g < 60) return g; }
      return 0;
    }
    function perView() {
      var w = slider.clientWidth, iw = items[0].getBoundingClientRect().width || w, g = gapPx();
      return Math.max(1, Math.round((w + g) / (iw + g)));
    }
    function last() { return Math.max(0, items.length - perView()); }
    // pagination de la source : un point par page (ex. 9 avis, 3 visibles -> 3 points),
    // fleche "precedent" masquee sur la premiere page, "suivant" sur la derniere
    var arrows = { prev: [], next: [] };
    function pages() { return Math.max(1, Math.ceil(items.length / perView())); }
    function page() { return Math.min(pages() - 1, Math.round(idx / perView())); }
    function paint() {
      var np = pages(), pg = page();
      dots.forEach(function (d, k) { d.style.display = k < np ? '' : 'none'; d.style.backgroundColor = k === pg ? on : off; });
      arrows.prev.forEach(function (b) { b.style.visibility = pg === 0 ? 'hidden' : ''; });
      arrows.next.forEach(function (b) { b.style.visibility = pg >= np - 1 ? 'hidden' : ''; });
    }
    function goPage(p) { var np = pages(); if (p < 0) p = 0; if (p > np - 1) p = np - 1; go(Math.min(p * perView(), last())); }
    function go(i, anim) {
      var m = last();
      if (i < 0) i = m;
      if (i > m) i = 0;
      idx = i;
      var g = gapPx(), iw = items[0].getBoundingClientRect().width;
      items.forEach(function (it, k) {
        it.style.transition = anim === false ? 'none' : 'transform .4s ease';
        it.style.transform = 'translate3d(' + (k * g - i * (iw + g)) + 'px,0,0)';
      });
      root.setAttribute('active-index', String(i));
      paint();
      root.dispatchEvent(new CustomEvent('sl:slide', { detail: i }));
    }
    $$('button', root).forEach(function (b) {
      if (b.closest('gp-carousel') !== root) return;
      var t = (b.getAttribute('aria-label') || '') + ' ' + b.className;
      if (/Back Arrow|gem-slider-previous|carousel-action-back/.test(t)) { arrows.prev.push(b); b.addEventListener('click', function (e) { e.preventDefault(); goPage(page() - 1); }); }
      else if (/Next Arrow|gem-slider-next|carousel-action-next/.test(t)) { arrows.next.push(b); b.addEventListener('click', function (e) { e.preventDefault(); goPage(page() + 1); }); }
    });
    dots.forEach(function (d, k) { d.addEventListener('click', function (e) { e.preventDefault(); goPage(k); }); });
    // glisser au doigt / a la souris
    var x0 = null, moved = false;
    slider.addEventListener('pointerdown', function (e) { x0 = e.clientX; moved = false; });
    slider.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { moved = true; goPage(page() + (dx < 0 ? 1 : -1)); }
    });
    slider.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    slider.style.touchAction = 'pan-y';
    // defilement automatique en boucle infinie (logos "Ci hanno visto su" : 1 logo / 1,5 s comme la source)
    var AUTO = { 'geZPtfuQSM': 1500 };
    function loopTick() {
      var n = items.length, g = gapPx(), iw = items[0].getBoundingClientRect().width;
      if (n <= perView()) return;
      idx = (idx + 1) % n;
      items.forEach(function (it, k) {
        var slot = ((k - idx) % n + n) % n;
        var wrapped = slot === n - 1;
        var x = (wrapped ? -1 : slot) * (iw + g) - k * iw;
        it.style.transition = 'transform .35s ease';
        it.style.transform = 'translate3d(' + x + 'px,0,0)';
        if (wrapped) setTimeout(function () {
          it.style.transition = 'none';
          it.style.transform = 'translate3d(' + ((n - 1) * (iw + g) - k * iw) + 'px,0,0)';
        }, 380);
      });
    }
    size();
    go(0, false);
    var auto = AUTO[root.getAttribute('data-id')];
    if (auto) setInterval(function () { if (!document.hidden) loopTick(); }, auto);
    window.addEventListener('load', function () { size(); go(idx, false); });
    window.addEventListener('resize', function () { size(); go(idx, false); });
    var api = { go: go, get index() { return idx; }, items: items, root: root };
    carousels[root.getAttribute('data-id')] = api;
    return api;
  }

  function initGallery() {
    var main = null, thumbs = null;
    Object.keys(carousels).forEach(function (k) {
      if (/^gp-carousel-/.test(k)) main = carousels[k];
      if (/^gp-gallery-/.test(k)) thumbs = carousels[k];
    });
    if (!main || !thumbs) return;
    function mark(i) {
      thumbs.items.forEach(function (t, k) { t.classList.toggle('active', k === i); });
    }
    thumbs.items.forEach(function (t, k) {
      t.addEventListener('click', function (e) { e.preventDefault(); main.go(k); });
    });
    main.root.addEventListener('sl:slide', function (e) {
      mark(e.detail);
      var tv = Math.max(0, e.detail - 2);
      thumbs.go(Math.min(tv, thumbs.items.length - 1));
    });
    mark(0);
  }

  /* ---------------- accordeons (un seul ouvert a la fois, comme la source) ---------------- */
  function initAccordions() {
    $$('gp-accordion').forEach(function (acc) {
      var items = $$('.gp-accordion-item', acc).filter(function (i) { return i.closest('gp-accordion') === acc; });
      function set(it, open) {
        var b = $('.gp-accordion-item_body', it), ic = $('.gp-accordion-item_icon', it);
        if (!b) return;
        if (open) { b.style.maxHeight = b.scrollHeight + 'px'; setTimeout(function () { if (it._open) b.style.maxHeight = 'none'; }, 500); }
        else { if (b.style.maxHeight === 'none' || !b.style.maxHeight) { b.style.maxHeight = b.scrollHeight + 'px'; b.offsetHeight; } b.style.maxHeight = '0px'; }
        it._open = open;
        if (ic) ic.classList.toggle('gp-rotate-180', open);
      }
      items.forEach(function (it) {
        var b = $('.gp-accordion-item_body', it);
        it._open = !!(b && b.style.maxHeight !== '0px');
        var h = $('.gp-accordion-item_header', it);
        if (!h) return;
        h.addEventListener('click', function (e) {
          e.preventDefault();
          var was = it._open;
          items.forEach(function (o) { if (o !== it && o._open) set(o, false); });
          set(it, !was);
        });
      });
    });
  }

  /* ---------------- guide des tailles (popup lv-quiz de la source) ---------------- */
  window.lvOpenQuiz = function (e) { if (e && e.preventDefault) e.preventDefault(); var o = $('#lvOverlay'); if (o) { o.classList.add('open'); document.body.style.overflow = 'hidden'; } };
  window.lvCloseQuiz = function (e) {
    var o = $('#lvOverlay'); if (!o) return;
    if (e === true || !e || e.target === o || (e.target && e.target.closest && e.target.closest('.lv-close'))) { o.classList.remove('open'); document.body.style.overflow = ''; }
  };
  window.lvSwitchTab = function (name) {
    $$('.lv-tab').forEach(function (t) { t.classList.toggle('active', t.id === 'lv-tab-' + name); });
    $$('.lv-panel').forEach(function (p) { p.classList.toggle('active', p.id === 'lv-panel-' + name); });
  };

  /* ---------------- date de livraison estimee (J+4 -> J+7, format de la source) ---------------- */
  function initEstimate() {
    var d2 = function (n) { return (n < 10 ? '0' : '') + n; };
    var fmt = function (d) { return d2(d.getDate()) + '/' + d2(d.getMonth() + 1) + '/' + d.getFullYear(); };
    var a = new Date(), b = new Date();
    a.setDate(a.getDate() + 4); b.setDate(b.getDate() + 7);
    $$('gp-estimate-date *').forEach(function (el) {
      if (el.children.length) return;
      if (/\d{2}\/\d{2}\/\d{4}\s*-\s*\d{2}\/\d{2}\/\d{4}/.test(el.textContent)) {
        el.textContent = el.textContent.replace(/\d{2}\/\d{2}\/\d{4}\s*-\s*\d{2}\/\d{2}\/\d{4}/, fmt(a) + ' - ' + fmt(b));
      }
    });
  }

  /* ---------------- offre (balisage Kaching de la source, deux etats) ---------------- */
  var K = { state: 1, slots: [] };
  function kRoot() { return $('[data-sl-kaching]'); }
  function kReadSlots(root) {
    return $$('.kaching-bundles__bar--selected .kaching-bundles__bar-variant-selects, .kaching-bundles__bar--selected .kaching-bundles__bar-variant-main', root)
      .filter(function (el, i, arr) { return !arr.some(function (o) { return o !== el && o.contains(el); }); })
      .map(function (el) {
        var s = $('select', el), c = $('.kaching-bundles__swatch-dropdown', el);
        return { size: s ? s.value : (PJ ? PJ.variants[0].option1 : ''), color: c ? c.getAttribute('data-value') : (PJ ? PJ.variants[0].option2 : '') };
      });
  }
  function setSwatch(dd, color) {
    dd.setAttribute('data-value', color);
    var sw = $('.kaching-bundles__swatch', dd), sp = $('span[role=combobox] > span', dd);
    if (sw) { sw.style.setProperty('--kaching-swatch-color', SW[color] || '#000'); sw.style.setProperty('--kaching-swatch-border-color', SW[color] || '#000'); }
    if (sp) sp.textContent = color;
  }
  function closeLists() { $$('.sl-swatch-list').forEach(function (l) { l.remove(); }); }
  function openList(dd) {
    closeLists();
    // {{ product | json }} ne donne que les noms d'options : les couleurs viennent des variantes
    var colors = PJ ? PJ.variants.map(function (v) { return v.option2; }).filter(function (c, i, a) { return a.indexOf(c) === i; }) : Object.keys(SW);
    var cb = $('span[role=combobox]', dd);
    var r = cb.getBoundingClientRect();
    var ul = document.createElement('div');
    ul.className = 'sl-swatch-list';
    ul.setAttribute('role', 'listbox');
    ul.style.cssText = 'position:absolute;z-index:50;left:0;top:' + (cb.offsetHeight + 2) + 'px;min-width:' + Math.max(r.width, 150) + 'px;background:#fff;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 4px 12px rgba(0,0,0,.12);padding:4px 0;max-height:260px;overflow:auto;font-size:14px;color:#000';
    colors.forEach(function (c) {
      var o = document.createElement('div');
      o.setAttribute('role', 'option');
      o.style.cssText = 'display:flex;align-items:center;gap:8px;padding:6px 10px;cursor:pointer;white-space:nowrap' + (c === dd.getAttribute('data-value') ? ';background:rgba(198,163,163,.25)' : '');
      o.innerHTML = '<span style="width:16px;height:16px;border-radius:50%;flex:0 0 16px;background:' + (SW[c] || '#000') + ';border:1px solid ' + (SW[c] || '#000') + '"></span><span>' + c + '</span>';
      o.addEventListener('click', function (e) { e.stopPropagation(); setSwatch(dd, c); closeLists(); cb.setAttribute('aria-expanded', 'false'); });
      ul.appendChild(o);
    });
    dd.style.position = 'relative';
    dd.appendChild(ul);
    cb.setAttribute('aria-expanded', 'true');
  }
  function kBind(root) {
    var bars = $$('.kaching-bundles__bar', root);
    bars.forEach(function (bar, i) {
      bar.addEventListener('click', function (e) {
        if (e.target.closest('select, .kaching-bundles__swatch-dropdown, .sl-swatch-list')) return;
        e.preventDefault();
        if (K.state !== i + 1) kSet(i + 1);
      });
    });
    $$('select.kaching-bundles__bar-variant-select', root).forEach(function (s) {
      s.addEventListener('change', function () { s.setAttribute('data-value', s.value); });
      s.addEventListener('click', function (e) { e.stopPropagation(); });
    });
    $$('.kaching-bundles__swatch-dropdown', root).forEach(function (dd) {
      setSwatch(dd, dd.getAttribute('data-value'));
      $('span[role=combobox]', dd).addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if ($('.sl-swatch-list', dd)) closeLists(); else openList(dd); });
    });
  }
  function kSet(n) {
    var root = kRoot(), tpl = $('#sl-k' + n);
    if (!root || !tpl) return;
    var keep = kReadSlots(root);
    var fresh = tpl.content.firstElementChild.cloneNode(true);
    root.parentNode.replaceChild(fresh, root);
    K.state = n;
    kBind(fresh);
    // reporter les choix deja faits
    var groups = $$('.kaching-bundles__bar--selected .kaching-bundles__bar-variant-selects', fresh);
    groups.forEach(function (g, i) {
      var v = keep[i] || keep[0];
      if (!v) return;
      var s = $('select', g); if (s && v.size) { s.value = v.size; s.setAttribute('data-value', v.size); }
      var dd = $('.kaching-bundles__swatch-dropdown', g); if (dd && v.color) setSwatch(dd, v.color);
    });
  }
  document.addEventListener('click', function (e) { if (!e.target.closest('.kaching-bundles__swatch-dropdown')) closeLists(); });

  function variantFor(size, color) {
    if (!PJ) return null;
    for (var i = 0; i < PJ.variants.length; i++) {
      var v = PJ.variants[i];
      if (v.option1 === size && v.option2 === color) return v;
    }
    return PJ.variants[0];
  }
  function addItems(items, btn) {
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '.7'; btn.style.pointerEvents = 'none'; }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function () { if (window.SLCart) window.SLCart.open(true); })
      .catch(function () { location.href = '/cart'; })
      .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; btn.style.pointerEvents = ''; } });
  }
  function initBuy() {
    var root = kRoot();
    if (root) kBind(root);
    $$('gp-product-button').forEach(function (pb) {
      var btn = $('button', pb);
      if (!btn) return;
      var inBuyBox = !!pb.closest('[class*="gps-596861019020591785"]');
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (inBuyBox && kRoot()) {
          var slots = kReadSlots(kRoot());
          if (!slots.length) slots = [{ size: PJ.variants[0].option1, color: PJ.variants[0].option2 }];
          if (K.state === 2 && slots.length === 1) slots.push(slots[0]);
          var items = slots.map(function (s) { var v = variantFor(s.size, s.color); return { id: v.id, quantity: 1 }; });
          addItems(items, btn);
        } else {
          addItems([{ id: PJ.variants[0].id, quantity: 1 }], btn);
        }
      });
    });
    $$('form[action="/cart/add"]').forEach(function (f) { f.addEventListener('submit', function (e) { e.preventDefault(); }); });
  }

  function init() {
    $$('gp-carousel').forEach(Carousel);
    initGallery();
    initAccordions();
    initEstimate();
    initBuy();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
